import { SMSBulkSendPayload, SMSPreviewResponse } from '@/new-transport/_models/transport-list.model';
import {
	BulkSendProgress,
	MessageGenerateAdapter,
	MessageTemplate,
	MessageTemplatePlaceholder,
} from '../message-generate.model';
import { TransportListApiService } from '@/new-transport/transport-list/_api/transport-list.api.service';
import { Injectable } from '@angular/core';
import { interval, Observable, of } from 'rxjs';
import { map, startWith, switchMap, takeWhile } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SmsGenerateAdapter implements MessageGenerateAdapter<SMSPreviewResponse, SMSBulkSendPayload[]> {
	constructor(private readonly api: TransportListApiService) {}

	fetchTemplates(): Observable<MessageTemplate[]> {
		return this.api.getSMSTemplateList();
	}

	fetchPlaceholders(id: number): Observable<MessageTemplatePlaceholder[]> {
		return this.api.getSMSTemplatePlaceholders(id);
	}

	createPreview({ itemsIds, message }: { itemsIds: number[]; message: string }): Observable<SMSPreviewResponse[]> {
		return this.api.createSMSPreview({ slots: itemsIds, message });
	}

	sendBulk(
		preview: SMSPreviewResponse[],
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		cc?: string[],
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		attachmentsByItem?: Record<number, File[]>,
	): Observable<SMSBulkSendPayload[] | BulkSendProgress> {
		const payload = preview.map((p) => ({
			phoneNumber: p.phone.replace(/\D/g, ''),
			message: p.message,
			slot: p.slotId,
		}));
		return this.api.createSMSBulkSend(payload).pipe(
			switchMap((initialMessages) => {
				const ids = initialMessages.map((m) => m.id);
				const total = ids.length;

				if (total === 0) {
					return of({ progress: 100 });
				}
				return interval(1000).pipe(
					startWith(0),
					switchMap(() => this.api.getSMSMessage(ids)),
					map((messages) => {
						const sentCount = messages.filter((m) => m.wasSent === true).length;
						return Math.round((sentCount / total) * 100);
					}),
					map((p) => ({ progress: p }) as BulkSendProgress),
					takeWhile((x) => x.progress < 100, true),
				);
			}),
		);
	}
}
